import { Component, Input } from '@angular/core';

@Component({
    selector: 'ridango-ui-ticket-wrapper',
    templateUrl: './ticket-wrapper.component.html',
})
export class TicketWrapperComponent {
    @Input() label = '';
    @Input() isPending = false;
    @Input() type = 'single';
    @Input() notification: string;
}
